/* gr-collection.js — Collection page behaviors
 * - Filter form: auto-submit on change (debounced)
 * - Mobile filter drawer open/close
 * - Sort select auto-submit
 * - Quick-add drawer (fetch /products/{handle}.js, variant picker, ATC)
 */
(function () {
  'use strict';

  // ── FILTER FORM ──────────────────────────────────────────
  var form = document.querySelector('[data-gr-coll-form]');
  if (form) {
    var submitTimer;
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement) && !(t instanceof HTMLSelectElement)) return;
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function () { form.submit(); }, 280);
    });

    // Mobile drawer toggle
    var rail = form.querySelector('[data-gr-coll-rail]');
    var openBtn = document.querySelector('[data-gr-coll-filter-btn]');
    var closeBtns = form.querySelectorAll('[data-gr-coll-filter-close]');
    if (openBtn && rail) {
      openBtn.addEventListener('click', function () {
        rail.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
      });
      closeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          rail.classList.remove('is-open');
          openBtn.setAttribute('aria-expanded', 'false');
        });
      });
    }

    // Active count badge
    var countEl = document.querySelector('[data-gr-coll-active-count]');
    if (countEl) {
      var active = form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
      var priceInputs = form.querySelectorAll('[name^="filter.v.price"]');
      priceInputs.forEach(function (i) { if (i.value) active++; });
      if (active > 0) { countEl.textContent = active; countEl.hidden = false; }
    }
  }

  // ── AJAX FILTERING ────────────────────────────────────────
  (function initCollectionAjax() {
    var collSection = document.querySelector('[data-gr-coll-section]');
    if (!collSection) return;
    var sid = collSection.dataset.sectionId;
    if (!sid) return;

    function fetchAndReplace(url) {
      var grid = collSection.querySelector('[data-gr-coll-grid]');
      if (grid) grid.style.opacity = '0.35';
      collSection.style.pointerEvents = 'none';

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sid)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.insertAdjacentHTML('beforeend', html);
          var fresh = tmp.querySelector('[data-gr-coll-section]') || tmp.querySelector('.gr-coll') || tmp.firstElementChild;
          if (fresh) {
            collSection.parentNode.replaceChild(fresh, collSection);
            collSection = fresh;
          }
          history.pushState(null, '', url);
        })
        .catch(function() { location.href = url; });
    }

    document.addEventListener('click', function(e) {
      var link = e.target.closest('.gr-coll__chip, .gr-coll__pill');
      if (link && link.href) {
        e.preventDefault();
        fetchAndReplace(link.href);
      }
    });

    document.addEventListener('change', function(e) {
      if (e.target.matches && e.target.matches('[data-gr-coll-sort]')) {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', e.target.value);
        u.searchParams.delete('page');
        fetchAndReplace(u.toString());
      }
    });

    window.addEventListener('popstate', function() { fetchAndReplace(location.href); });
  })();

  // ── QUICK-ADD ────────────────────────────────────────────
  var qa = document.getElementById('gr-quickadd');
  if (!qa) return;

  var qaEl = {
    eyebrow: qa.querySelector('[data-gr-qa-eyebrow]'),
    title: qa.querySelector('[data-gr-qa-title]'),
    img: qa.querySelector('[data-gr-qa-img]'),
    desc: qa.querySelector('[data-gr-qa-desc]'),
    price: qa.querySelector('[data-gr-qa-price]'),
    options: qa.querySelector('[data-gr-qa-options]'),
    body: qa.querySelector('[data-gr-qa-body]'),
    loading: qa.querySelector('[data-gr-qa-loading]'),
    submit: qa.querySelector('[data-gr-qa-submit]'),
    ctaLabel: qa.querySelector('[data-gr-qa-cta-label]'),
    link: qa.querySelector('[data-gr-qa-link]'),
  };

  var state = { product: null, selected: {}, variant: null };

  function openQA() {
    qa.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gr-cart-open');
  }
  function closeQA() {
    qa.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gr-cart-open');
  }
  qa.querySelectorAll('[data-gr-qa-close]').forEach(function (b) { b.addEventListener('click', closeQA); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qa.getAttribute('aria-hidden') === 'false') closeQA(); });

  // Delegate clicks on [data-gr-quickadd]
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gr-quickadd]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    loadProduct(btn.dataset.handle);
  });

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }

  function loadProduct(handle) {
    openQA();
    qaEl.loading.hidden = false;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        state.product = p;
        state.selected = {};
        // default to first available variant
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        if (first) {
          first.options.forEach(function (val, i) { state.selected[i] = val; });
        }
        paintQA();
        qaEl.loading.hidden = true;
      })
      .catch(function () { closeQA(); });
  }

  function paintQA() {
    var p = state.product;
    qaEl.eyebrow.textContent = (p.type || 'Product');
    qaEl.title.textContent = p.title;
    var imgSrc = '';
    if (typeof p.featured_image === 'string') imgSrc = p.featured_image;
    else if (p.featured_image && p.featured_image.src) imgSrc = p.featured_image.src;
    else if (p.images && p.images.length) imgSrc = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    qaEl.img.textContent = '';
    if (imgSrc) {
      var imgEl = document.createElement('img');
      imgEl.src = imgSrc;
      imgEl.alt = p.title;
      qaEl.img.appendChild(imgEl);
    }
    qaEl.desc.textContent = (p.description || '').replace(/<[^>]+>/g, '').slice(0, 120);
    qaEl.link.href = '/products/' + p.handle;

    // Render option chips
    qaEl.options.innerHTML = '';
    if (p.options && p.options.length === 1 && p.variants.length === 1) {
      // Single-variant product — skip option picker entirely
    } else {
      p.options.forEach(function (opt, i) {
        var optName = typeof opt === 'string' ? opt : (opt.name || opt);
        var wrap = document.createElement('div');
        wrap.className = 'gr-qa__opt';
        var lbl = document.createElement('span');
        lbl.className = 'gr-qa__opt-name';
        lbl.textContent = optName;
        wrap.appendChild(lbl);

        var values = document.createElement('div');
        values.className = 'gr-qa__opt-values';

        // Unique values for this position
        var seen = {};
        p.variants.forEach(function (v) {
          var val = v.options[i];
          if (seen[val]) return;
          seen[val] = true;
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'gr-qa__chip';
          chip.textContent = val;
          // available test: any variant matching selected-so-far with this value
          var trial = Object.assign({}, state.selected, {}); trial[i] = val;
          var match = variantFor(trial);
          if (match && !match.available) chip.classList.add('is-unavailable');
          if (state.selected[i] === val) chip.classList.add('is-active');
          chip.addEventListener('click', function () {
            state.selected[i] = val;
            paintQA();
          });
          values.appendChild(chip);
        });

        wrap.appendChild(values);
        qaEl.options.appendChild(wrap);
      });
    }

    // Resolve current variant
    state.variant = variantFor(state.selected);
    if (state.variant) {
      qaEl.price.textContent = money(state.variant.price);
      if (state.variant.available) {
        qaEl.submit.disabled = false;
        qaEl.ctaLabel.textContent = 'Add to cart — ' + money(state.variant.price);
      } else {
        qaEl.submit.disabled = true;
        qaEl.ctaLabel.textContent = 'Sold out';
      }
    } else {
      qaEl.submit.disabled = true;
      qaEl.ctaLabel.textContent = 'Select options';
    }
  }

  function variantFor(sel) {
    return state.product.variants.find(function (v) {
      return v.options.every(function (val, i) { return sel[i] === val; });
    }) || null;
  }

  qaEl.submit.addEventListener('click', function () {
    if (!state.variant || !state.variant.available) return;
    qaEl.submit.disabled = true;
    qaEl.ctaLabel.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        closeQA();
        window.dispatchEvent(new CustomEvent('gr:cart:open'));
      })
      .catch(function () {
        qaEl.submit.disabled = false;
        qaEl.ctaLabel.textContent = 'Try again';
      });
  });
})();
